import axios from "axios";
import appConfig from "../config/api.config";

const base = appConfig.BASE_URL;
const prefix = base ? `${base}/s1` : "/s1";

const request = axios.create({
  baseURL: prefix,
  withCredentials: true,
  transformResponse: [
    (response) => {
      if (!response) return null;
      const parsed = JSON.parse(response);
      if (parsed.error) return parsed;
      return Object.prototype.hasOwnProperty.call(parsed, "data")
        ? parsed.data
        : parsed;
    },
  ],
});

export default request;
